module.exports = __webpack_public_path__ + "img/person-white.aef31f6c.svg";